import { createMachine } from "xstate";
import {
  fetchOrchestrators,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

type IEvent =
  | { type: "SUBMIT" }
  | { type: "ERROR" }
  | { type: "ANOTHER_ORDER_EXISTS" }
  | { type: "SUCCESS"; orchestrator: IMultiOrderOrchestrator | undefined };

export const mobileOfferDetailsMachine = createMachine<IEvent>(
  {
    schema: {
      events: {} as IEvent,
    },
    initial: "start",
    states: {
      start: {
        on: {
          SUBMIT: {
            target: "checkOrchestrator",
          },
        },
      },
      checkOrchestrator: {
        invoke: {
          src: "fetchOrchestrator",
        },
        on: {
          SUCCESS: {
            actions: "onSubmit",
          },
          ANOTHER_ORDER_EXISTS: {
            actions: "onErrorRedirect",
            target: "start",
          },
          ERROR: {
            target: "start",
          },
        },
      },
    },
  },
  {
    services: {
      fetchOrchestrator: () => {
        return async (callback) => {
          try {
            const orchestrators = (await fetchOrchestrators()).unwrap();
            const isMultiorderInProgress =
              orchestrators.multiOrder &&
              orchestrators.multiOrder.state !== "START";
            const isFtthInProgress =
              orchestrators.ftth && orchestrators.ftth.orderStatus === "Draft";

            if (isMultiorderInProgress || isFtthInProgress) {
              return callback({
                type: "ANOTHER_ORDER_EXISTS",
              });
            }

            return callback({
              type: "SUCCESS",
              orchestrator: orchestrators.multiOrder,
            });
          } catch {
            callback({ type: "ERROR" });
          }
        };
      },
    },
  },
);
